import { render, staticRenderFns } from "./Component-UserOrgControl.vue?vue&type=template&id=4205c8d0"
import script from "./Component-UserOrgControl.vue?vue&type=script&lang=js"
export * from "./Component-UserOrgControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports